module.exports = __webpack_public_path__ + "img/password.edb96aed.svg";